import PersonContainer from './PersonContainer';

export default PersonContainer;
